/* global google */
import React, { Component } from "react";
import { withScriptjs, withGoogleMap } from "react-google-maps";
import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";
import _ from "lodash";
import Geocode from "react-geocode";
import api from "../api";
import axios from "axios";

const Map = withScriptjs(
  withGoogleMap(props => (
    <div className="mt-0 mb-0">
      <StandaloneSearchBox
        ref={props.onSearchBoxMounted}
        onPlacesChanged={e => props.onPlacesChanged(e)}
      >
        <div className="MuiFormControl-root MuiTextField-root mr-2 mt-0 MuiFormControl-marginNormal">
          <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedStart">
            <div className="MuiInputAdornment-root MuiInputAdornment-positionStart">
              <span
                className="MuiTypography-root MuiTypography-caption"
                style={{
                  minWidth: 50,
                  marginRight: 10,
                  fontSize: props.fontSize ? props.fontSize : "0.75rem"
                }}
              >
                Ubicación{" "}
              </span>
            </div>
            <input
              type="text"
              placeholder="Ingrese locación"
              className="MuiInputBase-input MuiInput-input MuiInputBase-inputAdornedStart"
              value={props.value}
              onChange={e => props.onChange(e)}
              style={{
                minWidth: 150,
                fontSize: props.fontSize ? props.fontSize : "0.75rem"
              }}
            />
          </div>
        </div>
      </StandaloneSearchBox>
      <ol>
        {props.places.map(({ formatted_address, geometry: { location } }) => (
          <li>{formatted_address}</li>
        ))}
      </ol>
    </div>
  ))
);

class googleMapsStandAlone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: parseFloat(process.env.REACT_APP_AUTOCORP_LAT),
        lng: parseFloat(process.env.REACT_APP_AUTOCORP_LONG)
      },
      google_api_key: process.env.REACT_APP_GOOGLE_KEY
    };
  }

  componentWillReceiveProps(nextProps) {
    this.georefenceLocation(nextProps.location);
  }

  componentDidMount() {
    var location = this.props.location;
    this.georefenceLocation(location);
  }

  georefenceLocation = location => {
    const refs = {};
    var places = [];
    var address_search = null;
    const google_api_key = this.state.google_api_key;
    if (location.lat !== "" && location.lng !== "") {
      if (location.address) {
        this.setState({ address_search: location.address });
        return;
      }
      Geocode.setApiKey(google_api_key);
      Geocode.setLanguage("es");
      Geocode.setRegion("es");
      Geocode.enableDebug();
      Geocode.fromLatLng(
        parseFloat(location.lat),
        parseFloat(location.lng)
      ).then(
        response => {
          address_search = response.results[0].formatted_address;
          this.setState({ address_search: address_search });
        },
        error => {
          console.error(error);
        }
      );
    }

    this.setState({
      places: places,
      onSearchBoxMounted: ref => {
        refs.searchBox = ref;
      }
    });
  };

  onPlacesChanged = e => {
    var places = this.state.searchBox.getPlaces();
    const nextMarkers = places.map(place => ({
      position: place.geometry.location
    }));
    var address_components = places[0].address_components;
    var province = "";
    var state = "";
    if (address_components[0]["types"].includes("street_number")) {
      province = address_components[4].long_name;
      state = address_components[3].long_name;
      if (address_components[4].short_name === "CABA") {
        state = "CABA";
      }
    } else {
      province = address_components[2].long_name;
      state = address_components[1].long_name;
      if (address_components[2].short_name === "CABA") {
        state = "CABA";
      }
    }

    var nextCenter = _.get(nextMarkers, "0.position", this.state.center);
    nextCenter.province = province;
    nextCenter.state = state;
    nextCenter.address = places[0].formatted_address;
    this.props.onChange(nextCenter);
    this.setState({ address_search: places[0].formatted_address });
  };

  onSearchBoxMounted = ref => {
    this.setState({ searchBox: ref });
  };

  onMapMounted = ref => {
    this.setState({ ref: ref });
  };

  onSearch = e => {
    this.setState({ address_search: e.target.value });
  };
  render() {
    return (
      <div className="row">
        <div className="col col-sm-11">
          <Map
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBdMpcA_SncYL2mPdjNtZy4_MrFskiWPVY&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div />}
            mapElement={<div style={{ height: `100%` }} />}
            places={this.state.places}
            fontSize={this.props.fontSize}
            value={this.state.address_search}
            onSearchBoxMounted={this.onSearchBoxMounted}
            onPlacesChanged={this.onPlacesChanged}
            onChange={this.onSearch}
          />
        </div>
      </div>
    );
  }
}

export default googleMapsStandAlone;
